
      import Delivered from './delivered.vue'
      import type { App, Plugin } from 'vue'

      export const DeliveredPlugin: Plugin = {
        install(app: App) {
          app.component('Delivered', Delivered)
        },
      }
      export { Delivered }
      